module.exports = {"370982001":"青云街道","370982002":"新汶街道","370982003":"新甫街道","370982101":"东都镇","370982102":"小协镇","370982103":"翟镇","370982104":"泉沟镇","370982105":"羊流镇","370982106":"果都镇","370982107":"西张庄镇","370982108":"天宝镇","370982110":"楼德镇","370982111":"禹村镇","370982112":"宫里镇","370982113":"谷里镇","370982114":"石莱镇","370982115":"放城镇","370982116":"刘杜镇","370982117":"汶南镇","370982119":"龙廷镇","370982203":"岳家庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370982.json
// module id = 1441
// module chunks = 0